const t = {
  name: "Netherlands",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.5746 5.16054L11.9999 1.58582L8.42525 5.16048C7.11866 4.42163 5.60877 4 4 4H3V13C3 17.6343 6.49871 21.448 11 21.9451V22H13V21.9451C17.5013 21.448 21 17.6343 21 13V4H20C18.3912 4 16.8812 4.42166 15.5746 5.16054ZM13.9349 6.34927C13.15 7.06542 12.4924 7.91875 12 8.87141C11.5076 7.91871 10.8499 7.06535 10.065 6.34917L11.9999 4.41424L13.9349 6.34927ZM5 6.0708C8.39353 6.55563 11 9.47183 11 13V19.9292C7.60647 19.4444 5 16.5282 5 13V6.0708ZM19 13C19 16.5282 16.3935 19.4444 13 19.9292V13C13 9.47183 15.6065 6.55563 19 6.0708V13Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Netherlands
};
